import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	disabledItemAriaLabel: {
		id: 'navigation.global-shortcuts.menu-link-item.disabled-item-aria-label',
		description:
			'Additional context after the label text for screen reader users when an item is disabled',
		defaultMessage: '(currently unavailable)',
	},
	loadingItemAriaLabel: {
		id: 'navigation.global-shortcuts.menu-link-item.loading-item-aria-label',
		description:
			'Additional context after the label text for screen reader users when an item is loading',
		defaultMessage: '(loading)',
	},
	linkExternalIconLabel: {
		id: 'navigation.global-shortcuts.menu-link-item.link-external-item-label',
		description: 'Label for the link external icon',
		defaultMessage: 'Open external link icon',
	},
});
